/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forside_Example_Step_2Inputs */

const da_forside_example_step_2 = /** @type {(inputs: Forside_Example_Step_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log ind, og opret en klasse med tre elevnumre og en ny prøve.`)
};

/** @type {(inputs: Forside_Example_Step_2Inputs) => LocalizedString} */
const en_forside_example_step_2 = da_forside_example_step_2;

/**

* @param {Forside_Example_Step_2Inputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const forside_example_step_2 = /** @type {((inputs?: Forside_Example_Step_2Inputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forside_Example_Step_2Inputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forside_example_step_2(inputs)
	return /** @type {LocalizedString} */ ("Log ind, og opret en klasse med tre elevnumre og en ny prøve.")
});